import styled from "styled-components";
import Card from "../Card";


export const ProductFilterCardStyled = styled(Card)`
    display:flex;
    flex-direction : column;
    gap : 1rem;

    box-shadow : unset;
    max-width:100%;
    width:95%;
    margin : auto ;
    path {
        fill : grey;
    }

    .filter-item {
        border : solid 1px #646464;
        border-radius : 5px;
        padding : 5px;
        width:100%;
    }

    button {
        padding : 5px;
    }

    .price-header{
        color:white;
        margin-left:10px;
    }

    .color-filter-wrapper{
        gap:0.3rem;
        flex-wrap: wrap;
    }

    .color-filter-item{
        width:17px;
        height:17px;
    }

    .sizes-filter-item{
        padding-right: 5px;
        padding-left: 5px;
        border-radius : 5px;
        font-size : smaller;
    }

    .rotate{
        transform : rotate(90deg);

        &:hover{
            transform : rotate(90deg) scale(1.1);
        }
    }
    
    img.swatch-value-filter{
        border-radius: 5px;
        margin-left : 10px;
    }

    @media only screen and (max-width : 1024px){
        background-color : transparent;
        width : 100%;
        max-width : 100%;
        height : 100%;
        overflow : hidden;
        margin-top : 3rem;
    }

    @media only screen and (min-width : 1980px){
        font-size : 0.8vw;

        

        .filter-item span , .filter-item p, .price-header {
            font-size : 0.8vw;
        }

        .view-button > div{
            height:100%;
            width:1vw;
        }

        .color-filter-wrapper{
            margin-top:0.1vw;
            margin-bottom:0.2vw;
        }

        .color-filter-item{
            width:1vw;
            height:1vw;
            border-radius : 6px;
        }

        .sizes-filter-item{
            min-width:1.2vw;
            height:1.2vw;
            border-radius : 6px;
        }

        .MuiSvgIcon-root{
            width:1vw;
            height:1vw;
        }
    }

`